import { render } from "./AccountConfirmationContainer.vue?vue&type=template&id=06888b2b"
import script from "./AccountConfirmationContainer.vue?vue&type=script&lang=js"
export * from "./AccountConfirmationContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__